import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  // public allowedExtensions = environment.validation.allowedPaymentExtensions;
  constructor() {}

  validateInputFile(
    files: FileList,
    allowedExtensions: string,
    maxFileSize: number
  ): string {
    if (!files || files.length <= 0) {
      return 'File is required !';
    }
    const fileExtension = files[0].name.substring(
      files[0].name.lastIndexOf('.')
    );

    // alert(JSON.stringify(fileExtension));
    if (!allowedExtensions.split(',').includes(fileExtension.toLowerCase())) {
      return `Invalid file format. Only allowed ${allowedExtensions} !`;
    }

    const fileSize = Math.max(files[0].size / 1024 / 1024);
    // console.log('fileSize', fileSize);
    if (fileSize > maxFileSize) {
      // return `${files[0].name}, max allowed file size : ${maxFileSize} MB `;
      return `Max allowed file size : ${maxFileSize} MB !`;
    }

    return '';
  }

  public noWhitespaceValidator(control: FormControl): any {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid
      ? null
      : {
          whitespace: true,
        };
  }

  // Formats a naive local date-time string (e.g. "2026-12-23T15:00:00", no
  // timezone offset) WITHOUT going through Date parsing - `new Date(...)` on
  // a timezone-less string can silently shift the displayed time by hours in
  // some browsers. Used for backend-provided timestamps like
  // profile-correction-eligibility's eligibleAt, which must be shown exactly
  // as returned.
  formatServerDateTime(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value);
    if (!match) {
      return value;
    }
    const [, year, month, day, hour, minute] = match;
    const hourNum = parseInt(hour, 10);
    const period = hourNum >= 12 ? 'PM' : 'AM';
    const displayHour = hourNum % 12 === 0 ? 12 : hourNum % 12;
    return `${day}-${month}-${year} ${String(displayHour).padStart(2, '0')}:${minute} ${period}`;
  }
}
